import {getCycleDataFromParent, getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {getCPTList, getStowFilters} from "../resources/StowResource";

export const OPTIONS_ADDED_OR_CHANGED = "OPTIONS_ADDED_OR_CHANGED";
export const VIEW_CHANGED = "VIEW_CHANGED";
export const OPTION_REMOVED = "OPTION_REMOVED";
export const OPTION_REMOVE_ALL = "OPTION_REMOVE_ALL";
export const OPTIONS_BUTTON_CLICKED = "OPTIONS_BUTTON_CLICKED";
export const FETCH_OPTIONS_CALL_BEGIN = "FETCH_OPTIONS_CALL_BEGIN";
export const FETCH_CAPABILITY_CALL_SUCCESS = "FETCH_CAPABILITY_CALL_SUCCESS";
export const FETCH_CYCLES_CALL_SUCCESS = "FETCH_CYCLES_CALL_SUCCESS";
export const CPT_ADDED_OR_CHANGED = "CPT_ADDED_OR_CHANGED";
export const FETCH_CPT_CALL_SUCCESS = "FETCH_CPT_CALL_SUCCESS";
export const FETCH_FILTERS_CALL_SUCCESS = "FETCH_FILTERS_CALL_SUCCESS";
export const FETCH_OPTIONS_CALL_FAILURE = "FETCH_OPTIONS_CALL_FAILURE";
export const NAVIGATION_ADDED = "NAVIGATION_ADDED";
export const NAVIGATION_REMOVED = "NAVIGATION_REMOVED";
export const ASSIGN_CPT_LABEL = "ASSIGN_CPT_LABEL"
export const ASSIGN_FILTER_IDENTIFIER = "ASSIGN_FILTER_IDENTIFIER"

/**
 * Fetch Options call begin.
 */
export const fetchOptionsCallBegin = () => ({
    type: FETCH_OPTIONS_CALL_BEGIN
});

/**
 * Fetch Capability call success.
 */
export const fetchCapabilityCallSuccess = capabilityResponse => ({
    type: FETCH_CAPABILITY_CALL_SUCCESS,
    capabilityResponse
});

/**
 * Fetch Cycles call success.
 */
export const fetchCyclesCallSuccess = cyclesResponse => ({
    type: FETCH_CYCLES_CALL_SUCCESS,
    cyclesResponse
});

/**
 * Fetch CPT call success.
 */
export const fetchCPTCallSuccess = CPTResponse => ({
    type: FETCH_CPT_CALL_SUCCESS,
    CPTList: CPTResponse
});

export const assignCPTLabel = CPTResponse => ({
    type: ASSIGN_CPT_LABEL,
    CPTLabel: CPTResponse
});

export const assignFilterIdentifier = CPTResponse => ({
    type: ASSIGN_FILTER_IDENTIFIER,
    filterIdentifier: CPTResponse
});

/**
 * Fetch Filters call success.
 */
export const fetchFiltersCallSuccess = filters => ({
    type: FETCH_FILTERS_CALL_SUCCESS,
    filters
});

/**
 * Fetch Options call failure
 */
export const fetchOptionsCallFailure = error => ({
    type: FETCH_OPTIONS_CALL_FAILURE,
    error
});

export const fetchCapability = () => {
    return async dispatch => {
        dispatch(fetchOptionsCallBegin());
        try {
            const capabilityResponse = await getNodeCapabilityFromParent();
            dispatch(fetchCapabilityCallSuccess(capabilityResponse));
        } catch (error) {
            return dispatch(fetchOptionsCallFailure(error.response));
        }
    };
}

export const fetchCycles = () => {
    return async dispatch => {
        try {
            dispatch(fetchOptionsCallBegin());
            const cyclesResponse = await getCycleDataFromParent();
            dispatch(fetchCyclesCallSuccess(cyclesResponse));
        } catch (error) {
            return dispatch(fetchOptionsCallFailure(error.response));
        }
    };
}

export const fetchCPTList = (nodeId) => {
    return async dispatch => {
        try {
            dispatch(fetchOptionsCallBegin());
            const CPTResponse = await getCPTList(nodeId);
            dispatch(fetchCPTCallSuccess(CPTResponse.CPTList));
            dispatch(assignCPTLabel(CPTResponse.CPTTypeLabelKey));
            dispatch(assignFilterIdentifier(CPTResponse.filterIdentifier));
        } catch (error) {
            return dispatch(fetchOptionsCallFailure(error.response));
        }
    };
}

export const fetchFilters = (nodeId) => {
    return async dispatch => {
        try {
            dispatch(fetchOptionsCallBegin());
            const filters = await getStowFilters(nodeId);
            dispatch(fetchFiltersCallSuccess(filters));
        } catch (error) {
            return dispatch(fetchOptionsCallFailure(error.response));
        }
    };
}

export const optionsButtonClicked = () => ({
    type: OPTIONS_BUTTON_CLICKED
});

export const optionsAddedOrChanged = options => ({
    type: OPTIONS_ADDED_OR_CHANGED,
    options: options
});

export const CPTAddedOrChanged = options => ({
    type: CPT_ADDED_OR_CHANGED,
    options: options
});

export const viewChanged = view => ({
    type: VIEW_CHANGED,
    view: view
});

export const optionRemoved = (removedOption, removedOptionValue) => ({
    type: OPTION_REMOVED,
    removedOption,
    removedOptionValue
});

export const optionRemoveAll = () => ({
    type: OPTION_REMOVE_ALL
})

export const navigationAdded = navigationOption => ({
    type: NAVIGATION_ADDED,
    navigationOption
});

export const navigationRemoved = navigationIndex => ({
    type: NAVIGATION_REMOVED,
    navigationIndex
});


// WEBPACK FOOTER //
// ./src/actions/OptionsActionsV2.js